import en from './en-US';
import fr from './fr-CA';

// eslint-disable-next-line
export default  {
    ...en,
    ...fr,
}